module.exports = __webpack_public_path__ + "static/media/upload-image.b643b390.svg";